module.exports = __webpack_public_path__ + "static/media/rvn.da1db9d2.svg";